import {Route, Switch} from "react-router-dom";
import Main from "./pages/Main";
import Registration from "./pages/Registration";
import Login from "./pages/Login";
import SurveyList from "./pages/Surveys/List";
import OrganizationsList from "./pages/Organizations/List";
import ReactGA from "react-ga";
import EventsPage from "./pages/Events/EventsPage";
import EventPage from "./pages/Events/Event";
import TagManager from 'react-gtm-module'

ReactGA.initialize(process.env.REACT_APP_GA_ID, {});
TagManager.initialize({
    gtmId: process.env.REACT_APP_GTM_ID
});

export default function Routes() {
    return (
        <Switch>
            <Route exact path="/">
                <Main />
            </Route>
            {/*<Route exact path="/account/registration">
                <Registration />
            </Route>*/}
            <Route exact path="/account/login">
                <Login />
            </Route>
            <Route path="/surveys">
                <SurveyList />
            </Route>
            <Route exact path="/organizations">
                <OrganizationsList />
            </Route>
            <Route path="/conferences">
                <EventsPage />
            </Route>
            <Route
                path={`/conference/:id`}
            >
                <EventPage />
            </Route>
        </Switch>
    )
}
